function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { HStack, Pressable, Text, useBreakpointValue } from 'native-base';
import { Linking } from 'react-native';
import React, { memo } from 'react';
import { useOfferCardContext } from '../../../context';
import { CaretRightIcon } from '../../../../assets';
import Typography from '../Typography/Typography';
const DialInText = _ref => {
  let {
    content,
    metadata,
    type = 'freedom-dial-in',
    event: {
      action
    } = {
      action: 'ButtonClick'
    }
  } = _ref;
  const {
    href,
    values,
    ...rest
  } = metadata;
  const {
    logUserEvent,
    cardType
  } = useOfferCardContext() || {
    cardType: ''
  };
  const showContent = useBreakpointValue({
    base: false,
    sm: false,
    md: true,
    lg: true
  });
  const isSmallScreenView = useBreakpointValue({
    base: true,
    sm: true,
    md: true,
    lg: false
  });
  if (type === 'dial-in') return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pressable, {
    pointerEvents: isSmallScreenView ? 'auto' : 'none'
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: "3"
  }, /*#__PURE__*/React.createElement(Text, _extends({
    color: isSmallScreenView ? 'primary.400' : 'text.running',
    fontSize: "lg",
    lineHeight: '21',
    onPress: async event => {
      if (!isSmallScreenView) {
        event.preventDefault();
      } else {
        if (href) {
          const canOpen = await Linking.canOpenURL(`tel:${values.tollFreeNo}`);
          if (canOpen) await Linking.openURL(`tel:${values.tollFreeNo}`);
        }
        logUserEvent({
          action: action,
          type: cardType,
          description: `${action} - ${cardType}`
        });
      }
    }
  }, rest, {
    testID: `${cardType}${content}`,
    accessibilityLabel: content,
    accessibilityRole: "text"
  }), /*#__PURE__*/React.createElement(Typography, {
    fontSize: "lg",
    fontWeight: "medium",
    metadata: metadata,
    content: content
  })), !isSmallScreenView ? null : /*#__PURE__*/React.createElement(CaretRightIcon, null))));
  return /*#__PURE__*/React.createElement(Pressable, {
    pointerEvents: isSmallScreenView ? 'auto' : 'none'
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: "3"
  }, /*#__PURE__*/React.createElement(Text, _extends({
    color: isSmallScreenView ? 'primary.400' : 'text.running',
    fontSize: "lg",
    lineHeight: '21',
    onPress: async event => {
      if (!isSmallScreenView) {
        event.preventDefault();
      } else {
        if (href) {
          const canOpen = await Linking.canOpenURL(`tel:${values.tollFreeNo}`);
          if (canOpen) await Linking.openURL(`tel:${values.tollFreeNo}`);
        }
        logUserEvent({
          action: action,
          type: cardType,
          description: `${action} - ${cardType}`
        });
      }
    }
  }, rest, {
    testID: `${cardType}${content}`,
    accessibilityLabel: content,
    accessibilityRole: "text"
  }), showContent ? /*#__PURE__*/React.createElement(Typography, {
    fontSize: "lg",
    fontWeight: "medium",
    metadata: metadata,
    content: content
  }) : 'CALL US'), !isSmallScreenView ? null : /*#__PURE__*/React.createElement(CaretRightIcon, null)));
};
export default /*#__PURE__*/memo(DialInText);
//# sourceMappingURL=DialInText.js.map